import { Perfil } from "./services/perfil.service";
import { ChangeDetectorRef, Component } from "@angular/core";

import { Platform } from "@ionic/angular";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { GlobalsService } from "./api/globals.service";
import { NavigationEnd, Router } from "@angular/router";
import { Location } from "@angular/common";
import { AuthService } from "./services/auth.service";

import { CartService } from "./services/cart.service";
import { AuthConstants } from "./config/auth-constants";

import { NavController } from "@ionic/angular";
import localeCO from "@angular/common/locales/es-CO";
import { registerLocaleData } from "@angular/common";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { ReferidosService } from "src/app/services/referidos.service";
import { Network } from "@ionic-native/network/ngx";
import { ToastService } from "./services/toast.service";
registerLocaleData(localeCO, "CO");

//import { HideHeaderDirective } from '../directives/hide-header/hide-header';
import { SearchService } from "./services/search.service";
import { MoreComponent } from "./components/more/more.component";
import { PopoverController } from "@ionic/angular";
import { UserComponent } from "./components/user/user.component";
import { NotiBellComponent } from "./components/noti-bell/noti-bell.component";
import { NotiFollowersComponent } from "./components/noti-followers/noti-followers.component";
import { TranslateService } from "@ngx-translate/core";
import { TranslationLoadedService } from "./services/translation-loaded.service";
import { ProductosService } from "./services/productos.service";
import { StorageService } from "./services/storage.service";
import { PerfilUser } from "./Enum/perfilUser.enum";
import { OnboardingService } from "./services/onboarding.service";
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  animations: [
    trigger("fadeInOut", [
      state("void", style({ opacity: 0 })),
      state("*", style({ opacity: 1 })),
      transition("void => *", animate("1000ms ease-in")),
      transition("* => void", animate("1000ms ease-out")),
    ]),
  ],
})
export class AppComponent {
  showTabs = true;
  public loaderToShow;
  navigate: any;
  navigatemenu: any;
  ismobile: boolean = false;
  dark = false;
  ruta: string;
  urlParts;
  displayUserData: any;
  username: string;
  rol: string;
  textSearch: string;
  language = "";
  dataLoaded = false;
  suscribeLicence: any;
  perfil: number;
  PerfilUserEnum = PerfilUser;

  public static cartLength: number;
  public static Cronocoins: number = 0;

  route: string;
  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    public globals: GlobalsService,
    private router: Router,
    location: Location,
    private authService: AuthService,
    public cart: CartService,
    public navCtrl: NavController,
    private referidosService: ReferidosService,
    public network: Network,
    public toastService: ToastService,
    private searchService: SearchService,
    private popoverController: PopoverController,
    private _translationLoadedService: TranslationLoadedService,
    private translate: TranslateService,
    private service: ProductosService,
    private onboardingService: OnboardingService
  ) {
    this.authService.suscribeLicence$.subscribe((res: any) => {
      this.getlicense();
      //this.suscribeLicence = res;
    });
    this.authService.userPerfil$.subscribe((res: number) => {
      this.perfil = res;
    });
    this._translationLoadedService.startLoading();
    this._translationLoadedService.isLoading$.subscribe((isLoading) => {
      this.dataLoaded = isLoading;
      if (!this.dataLoaded) {
        setTimeout(() => {
          this._translationLoadedService.finishLoading();
        }, 1100);
      }
    });

    this._translationLoadedService.defaultLanguage$.subscribe((lang) => {
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
    });
    this.translate.get("primary").subscribe((res: string) => {
      console.log("res languaje", res);
    });

    this.translate.onLangChange.subscribe(() => {
      this.sideMenu();
    });

    router.events.subscribe((val) => {
      if (location.path() != "") {
        this.route = location.path();
      } else {
        this.route = "Home";
      }
    });

    this.sideMenu();
    this.itemsMenu();
    this.ismobile = globals.isMobile;
    this.ruta = this.router.url;

    AppComponent.cartLength = 0;
    this.cart.get(AuthConstants.CART).then((res) => {
      //pudo generar un error
      if (res.length) {
        AppComponent.cartLength = res.length;
      }
    });
    this.initializeApp();

    //Borrar busqueda
    this.searchService.eventDelete.subscribe((res) => {
      this.textSearch = "";
    });
  }

  get staticCartL() {
    return AppComponent.cartLength;
  }
  get staticCronocoins() {
    return AppComponent.Cronocoins;
  }

  async initializeApp() {

    await this.platform.ready();
    
    if (this.statusBar) {
      this.statusBar.styleDefault();
    }

    await this.checkOnboarding();

    this.network.onDisconnect().subscribe(() => {
      this.toastService.presentToast("Desconectado");
    });
    this.network.onConnect().subscribe(() => {
      this.toastService.presentToast("Conectado");
    });

    this.username = "invitado";
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      //
      this.username = this.displayUserData?.nombre_apellido;
      if (this.displayUserData?.tutorid != undefined) {
        this.username += " - " + this.displayUserData?.tutorname;
      }
      this.rol = this.displayUserData?.rol;

      if (this.displayUserData?.id && this.displayUserData?.auth_key) {
        this.getlicense();
        this.referidosService
          .get(this.displayUserData?.id, this.displayUserData?.auth_key)
          .subscribe((res: any) => {
            //console.log(res);
            AppComponent.Cronocoins = res.cronocoins;
          });
      }
    });

    // this.platform.ready().then(async () => {
    //   this.statusBar.styleDefault();
    //   await this.checkOnboarding();
    //   console.log("url: " + this.route);
    // });
  }

  async checkOnboarding() {
    const hasSeenOnboarding = await this.onboardingService.hasSeenOnboarding();
    if (!hasSeenOnboarding && this.ismobile) {
      this.router.navigateByUrl("/auth/init", { replaceUrl: true });
    } 
  }

  getlicense() {
    this.service
      .getLicense(this.displayUserData.auth_key, this.displayUserData.id)
      .subscribe((response: any) => {
        this.suscribeLicence = response.suscripcion;
      });
  }

  updateDarkMode() {
    document.body.classList.toggle("dark", this.dark);
  }

  sideMenu() {
    this.navigate = [
      {
        title: "Inicio",
        url: "/cursos",
        icon: "home",
        pos: 1,
        group: 1,
      },
      {
        title: "Libros",
        url: "/libreria",
        icon: "book-outline",
        pos: 2,
        group: 2,
      },
      {
        title: "Foros",
        url: "/forum",
        icon: "school-outline",
        pos: 3,
        group: 2,
      },
      {
        title: "Cronocoins",
        url: "/cronocoins",
        icon: "logo-bitcoin",
        pos: 4,
        group: 3,
      },
      {
        title: "Premium",
        url: "/mislibros",
        icon: "cloud-outline",
        pos: 5,
        group: 4,
      },
      {
        title: "Perfil",
        url: "/profile",
        icon: "person-circle-outline",
        pos: 6,
        group: 4,
      },
      {
        title: "Carrito",
        url: "/checkout",
        icon: "cart-outline",
        pos: 7,
        group: 4,
      },
      {
        title: "Configuración",
        url: "/configuracion-privacidad",
        icon: "notifications-outline",
        pos: 9,
        group: 4,
      },
      {
        title: "Contáctanos",
        url: "/contac",
        icon: "mail-outline",
        pos: 9,
        group: 4,
      },
      {
        title: "Cerrar sesión",
        url: "/logout",
        icon: "close-outline",
        pos: 10,
        group: 4,
      },
      {
        title: "Más",
        url: "#",
        icon: "caret-down-outline",
        pos: 10,
        group: 4,
        expanded: false,
        items: [
          {
            title: "Quienes somos",
            url: "/whoAre",
            pos: 10,
            group: 4,
          },
          {
            title: "Trabaja con nosotros",
            url: "/work",
            pos: 10,
            group: 4,
          },
          {
            title: "Preguntas más frecuentes",
            url: "/ask",
            pos: 10,
            group: 4,
          },
          {
            title: "Términos y condiciones",
            url: "/termi",
            pos: 10,
            group: 4,
          },
          {
            title: "Tratamiento de datos",
            url: "/trata",
            pos: 10,
            group: 4,
          },
        ],
      },
    ];
  }

  itemsMenu() {
    this.navigatemenu = [
      {
        title: "Cronoleo",
        url: "/cursos",
        icon: "assets/imagenes/logos/logo-premium.png",
        object: "",
      },
      {
        title: "Search",
        url: "/search",
        icon: "chatbubbles-outline",
      },
    ];
  }

  logoutAction() {
    //this.navCtrl.navigateRoot('/login');
    this.authService.logout();
  }

  toCheckout() {
    //this.router.navigateByUrl('/checkout');
    if (!AppComponent.cartLength) {
      return;
    }
    this.navCtrl.navigateRoot("/checkout");
  }
  toLibrary() {
    this._translationLoadedService.startLoading();
    this.navCtrl.navigateRoot("/libreria");
    //this.router.navigateByUrl('/libreria');
  }
  aCursos() {
    this._translationLoadedService.startLoading();
    if (this.perfil == 1) {
      this.navCtrl.navigateRoot("/institute");
    } else {
      this.navCtrl.navigateRoot("/cursos");
    }
    //this.router.navigateByUrl('/libreria');
  }
  forum() {
    this._translationLoadedService.startLoading();
    this.navCtrl.navigateRoot(["/forum"]);
    //this.router.navigateByUrl('/libreria');
  }
  goProfile() {
    this._translationLoadedService.startLoading();
    this.navCtrl.navigateRoot(["/profile"]);
    //this.router.navigateByUrl('/libreria');
  }
  premium() {
    this._translationLoadedService.startLoading();
    this.navCtrl.navigateRoot(["/mislibros"]);
    //this.router.navigateByUrl('/libreria');
  }
  misCronocoins() {
    this._translationLoadedService.startLoading();
    this.navCtrl.navigateRoot("/cronocoins");
  }

  serchText() {
    this.searchService.event.emit(this.textSearch);
    if (this.textSearch != "") {
      this.navCtrl.navigateRoot("/search");
    }
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: MoreComponent,
      cssClass: "my-custom-class",
      event: ev,
      translucent: true,
      mode: "ios",
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log("onDidDismiss resolved with role", role);
  }

  async presentPopoverUser(ev: any) {
    const popover = await this.popoverController.create({
      component: UserComponent,
      cssClass: "config-pop-class",
      event: ev,
      translucent: true,
      mode: "ios",
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log("onDidDismiss resolved with role", role);
  }

  async presentNotifications(ev) {
    const popover = await this.popoverController.create({
      component: NotiBellComponent,
      cssClass: "config-pop-class",
      event: ev,
      translucent: true,
      mode: "ios",
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log("onDidDismiss resolved with role", role);
  }
  async presentFollowers(ev) {
    const popover = await this.popoverController.create({
      component: NotiFollowersComponent,
      cssClass: "config-pop-class",
      event: ev,
      translucent: true,
      mode: "ios",
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log("onDidDismiss resolved with role", role);
  }
}
